import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const Header = ({ isScrolled }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Check if we're on a landing or legal page
  const isSimplifiedHeader = [
    '/lander/free-trial-invitation', 
    '/privacy', 
    '/terms-of-service', 
  ].includes(location.pathname) || 
  location.pathname.startsWith('/ai-quiz');

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-md py-2' 
          : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <a href="/" className={`flex items-center ${isSimplifiedHeader ? 'flex-1 justify-center' : 'flex-1 md:flex-none justify-center md:justify-start'}`}>
          <img 
            src="https://media.salesintercept.com/Sales_Intercept_rec_Logo.png" 
            alt="Sales Intercept Logo" 
            className="h-10 md:h-12"
          />
        </a>
        
        {/* Desktop navigation - only show if not simplified header */}
        {!isSimplifiedHeader && (
          <nav className="hidden md:flex space-x-8 items-center">
            <a 
              href="#features" 
              className={`font-heading font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-purple-si' : 'text-gray-800 hover:text-purple-si'
              }`}
            >
              Features
            </a>
            <a 
              href="#pricing" 
              className={`font-heading font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-purple-si' : 'text-gray-800 hover:text-purple-si'
              }`}
            >
              Pricing
            </a>
            <a 
              href="https://dashboard.salesintercept.com/" 
              className={`font-heading font-medium transition-colors ${
                isScrolled ? 'text-gray-800 hover:text-purple-si' : 'text-gray-800 hover:text-purple-si'
              }`}
            >
              Login
            </a>
            <motion.a 
              href="https://dashboard.salesintercept.com/signup" 
              className="btn btn-primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Try For Free
            </motion.a>
          </nav>
        )}

        {/* Mobile menu button - only show if not simplified header */}
        {!isSimplifiedHeader && (
          <button 
            className="block md:hidden text-gray-800 focus:outline-none absolute right-4"
            onClick={toggleMenu}
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              ) : (
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 6h16M4 12h16M4 18h16" 
                />
              )}
            </svg>
          </button>
        )}
      </div>
      
      {/* Mobile navigation - only show if not simplified header */}
      {isMenuOpen && !isSimplifiedHeader && (
        <motion.div 
          className="md:hidden bg-white shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="container mx-auto px-4 py-4 space-y-4">
            <a 
              href="#features" 
              className="block py-2 text-gray-800 font-medium hover:text-purple-si"
              onClick={toggleMenu}
            >
              Features
            </a>
            <a 
              href="#pricing" 
              className="block py-2 text-gray-800 font-medium hover:text-purple-si"
              onClick={toggleMenu}
            >
              Pricing
            </a>
            <a 
              href="https://dashboard.salesintercept.com/" 
              className="block py-2 text-gray-800 font-medium hover:text-purple-si"
              onClick={toggleMenu}
            >
              Login
            </a>
            <a 
              href="https://dashboard.salesintercept.com/signup" 
              className="btn btn-primary w-full text-center"
              onClick={toggleMenu}
            >
              Try For Free
            </a>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;